import React from "react";
import { useTheme } from "styled-components";
import { Card, CardBody, CardHeader } from "../Card";
import { Box } from "../Box";
import { Label } from "../Text";
import { Flex } from "../Flex";
import { Icon } from "../Icon";
export var ChecklistStatusType;
(function (ChecklistStatusType) {
    ChecklistStatusType["COMPLETED"] = "completed";
    ChecklistStatusType["CURRENT"] = "current";
    ChecklistStatusType["PENDING"] = "pending";
})(ChecklistStatusType || (ChecklistStatusType = {}));
export const calculateItemStatus = (currentItem, itemNumber) => {
    if (currentItem === itemNumber) {
        return ChecklistStatusType.CURRENT;
    }
    if (currentItem > itemNumber) {
        return ChecklistStatusType.COMPLETED;
    }
    return ChecklistStatusType.PENDING;
};
const CurrentItemCircle = () => {
    const { colors: { checklistColors }, } = useTheme();
    return (React.createElement(Box, { "data-testid": "currentItemCircle", width: 4, height: 4, border: "4px solid", borderColor: checklistColors.currentItemCircleBorder, borderRadius: "50%", minWidth: 4 },
        React.createElement(Box, { mr: 2, height: 3, width: 3, backgroundColor: checklistColors.currentItemCircleBackground, borderRadius: "50%", marginLeft: 1, marginTop: 1, minWidth: 3 })));
};
const FutureItemCircle = () => {
    const { colors: { checklistColors }, } = useTheme();
    return (React.createElement(Box, { "data-testid": "futureItemCircle", border: "4px solid", borderColor: checklistColors.futureItemCircleBorder, height: 4, width: 4, minWidth: 4, borderRadius: "50%" }));
};
const DisplayIcon = ({ status }) => {
    const { colors: { checklistColors }, } = useTheme();
    if (status === ChecklistStatusType.CURRENT) {
        return React.createElement(CurrentItemCircle, null);
    }
    if (status === ChecklistStatusType.PENDING) {
        return React.createElement(FutureItemCircle, null);
    }
    return (React.createElement(Flex, { "data-testid": "doneItemCircle", alignItems: "center", justifyContent: "center", color: checklistColors.doneItemCheckmark, minWidth: 4 },
        React.createElement(Icon, { src: "CheckCircle", size: 32 })));
};
export const ChecklistElements = ({ children, checklistProps, isLastItem, showSeparation = true, status, }) => {
    const { colors: { checklistColors }, } = useTheme();
    return (React.createElement(Flex, { alignItems: "flex-start", flexDirection: "column", "data-testid": "checklist", m: 0 },
        React.createElement(Flex, { alignItems: "center", style: { gap: "16px", padding: "21px 0px" } },
            React.createElement(DisplayIcon, { status: status }),
            children && (React.createElement(Label, { "data-testid": "checklistLabel", sx: Object.assign({ fontSize: 2, fontWeight: status === ChecklistStatusType.CURRENT ? 600 : "normal" }, checklistProps) }, children))),
        showSeparation && !isLastItem && (React.createElement(Box, { borderBottom: 1, borderColor: checklistColors.separatorBorder, height: "0", "data-testid": "checklistSeparator", width: "100%" }))));
};
export const Checklist = ({ cardHeaderProps, cardProps, checklistProps, currentItem, listItems, showSeparation, title, }) => {
    const { colors } = useTheme();
    return (React.createElement(Card, Object.assign({}, cardProps),
        React.createElement(CardHeader, Object.assign({ p: "24px", color: colors.headerText, fontSize: 4, fontWeight: "700" }, cardHeaderProps), title),
        React.createElement(CardBody, { p: "24px", pb: "0" }, listItems.map((item, index) => (React.createElement(ChecklistElements, { key: `item-${index}`, isLastItem: index + 1 === listItems.length, showSeparation: showSeparation, status: calculateItemStatus(currentItem, index), checklistProps: checklistProps }, item))))));
};
